import * as React from "react";

function SvgTrash(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M14.409 2.462h-3.384V1.231A1.235 1.235 0 009.794 0H6.1a1.235 1.235 0 00-1.229 1.231v1.231H1.486a.306.306 0 00-.307.307v.923h13.538v-.923a.307.307 0 00-.308-.307zm-8.281 0H6.1V1.231h3.694v1.231zM2.409 14.769A1.235 1.235 0 003.64 16h8.616a1.234 1.234 0 001.23-1.231V4.923H2.409zm8.616-8.615h1.231v8.615h-1.231zm-2.462 0h1.231v8.615H8.563zm-2.461 0h1.23v8.615H6.1zm-2.462 0h1.231v8.615H3.64z" fill="currentColor" fillRule="evenodd" /></svg>;
}

const ForwardRef = React.forwardRef(SvgTrash);
export default ForwardRef;